export const ButtonSize = {
  XS: 'extra-small',
  SM: 'small',
  MD: 'medium',
  LG: 'large',
};

export type ButtonSize = (typeof ButtonSize)[keyof typeof ButtonSize];
